/*
 * @Author       : 四川华西绿舍建材有限公司
 * @Date         : 2022-06-24 15:53:24
 * @LastEditTime: 2025-03-31 10:26:27
 * @LastEditors: 刘小二
 * @Description  : 
 * @FilePath: /icps_pcweb/src/main.js
 */

import '@/styles/index.scss'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import Vue from 'vue'
import VueAMap from 'vue-amap'
import inputLimit from 'vue-input-limit'
import App from './App.vue'
import "./registerServiceWorker"
import router from './router'
import store from './store'
/*引入svg图*/
import { getButtonList } from "@/utils/auth"
import '@/utils/directives.js'
import gpcUI from 'gpc-ui'
import 'gpc-ui/lib/gpc-ui.css'
import Icon from 'vue2-svg-icon/Icon.vue'
import axios from "axios";
import './permission'
Vue.component('icon', Icon)
Vue.use(gpcUI)
// import 'babel-polyfill';
Object.defineProperty(Vue.prototype, '$ButtonList', { value: getButtonList })

import decimal from "@/utils/decimal"
Vue.prototype.decimal = decimal;

import * as filters from './filters'
//过滤器
Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key])
})
//组件内监听打印{{log(JSON.parse(JSON.stringify(scope.row)))}}
Vue.prototype.log = window.console.log

// 自定义输入限制
Vue.directive('inputLimit', inputLimit)

//同一路由报错问题
import Router from 'vue-router'
const routerPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return routerPush.call(this, location).catch(error => error)
}
//时间方法
Date.prototype.Format = function (fmt) { //author: meizz   
  var o = {
    "M+": this.getMonth() + 1,                 //月份   
    "d+": this.getDate(),                    //日   
    "h+": this.getHours(),                   //小时   
    "m+": this.getMinutes(),                 //分   
    "s+": this.getSeconds(),                 //秒   
    "q+": Math.floor((this.getMonth() + 3) / 3), //季度   
    "S": this.getMilliseconds()             //毫秒   
  };
  if (/(y+)/.test(fmt))
    fmt = fmt.replace(RegExp.$1, (this.getFullYear() + "").substr(4 - RegExp.$1.length));
  for (var k in o)
    if (new RegExp("(" + k + ")").test(fmt))
      fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
  return fmt;
};
let baseURL = "";
    if (process.env.NODE_ENV == "development") {
      baseURL = "/dev";
    } else if (process.env.VUE_APP_API_HOST) {
      baseURL = process.env.VUE_APP_API_HOST;
    }
axios({
  method: "post",
  url: baseURL + '/base/outer/no/login/query_page', // 请求地址
  headers: {
    "system-info" : 'icps',
  },
  data: {code:"ICPS_GDMAP_WEB",paramName:"",page:1,pageSize:10}, // 参数
  // responseType: "blob", // 表明返回服务器返回的数据类型
}).then(res => {
  let key = res.data.data.data[0].paramName || 'fea7a6671bef61d971294d987c80e748' //webJs key
  let code = res.data.data.data[0].paramValue || 'd5c6381fe3556f3bed87a53c430a331b' //webJs 安全秘钥
  initAMap(key,code)
}).catch(() => {
  initAMap('fea7a6671bef61d971294d987c80e748','d5c6381fe3556f3bed87a53c430a331b')
  
})

// 封装初始化函数
function initAMap(key,code) {
  VueAMap.initAMapApiLoader({
    key: key,
    plugin: [
      'Autocomplete', 'PlaceSearch', 'Scale', 'OverView', 'ToolBar',
      'MapType', 'PolyEditor', 'AMap.CircleEditor', 'AMap.Driving'
    ],
    v: "1.4.4",
    uiVersion: "1.0.11",
  });
  Vue.use(VueAMap);
  window._AMapSecurityConfig = {
    securityJsCode: code
  }
}
/*引入全局函数*/
import debounce from "@/utils/debounce"
import common from './common/common.js'
import regExp from './common/RegExpExprot.js'
Vue.use(common);
Vue.use(debounce);
Vue.prototype.$regExp = regExp
//引入vxe表格
import VXETable from 'vxe-table'
import VXETablePluginExportXLSX from 'vxe-table-plugin-export-xlsx'
import 'vxe-table/lib/style.css'
import 'xe-utils'
// VXETable.use(VXETablePluginExportXLSX)
VXETable.setConfig({
  zIndex:99999
})

Vue.use(VXETable)
Vue.prototype.$VXETable = VXETable
// import { VxeUI } from 'vxe-table'
import ExcelJS from 'exceljs'
VXETable.use(VXETablePluginExportXLSX, {
  ExcelJS
})
/*localForage  */
import localForage from 'localforage'
Vue.prototype.$forage = localForage;
//拖拽
import Sortable from "sortablejs"
Vue.prototype.$Sortable = Sortable;
//前端版本更新
// 引入版本提示（ version-polling）
import { createVersionPolling } from "version-polling"
// 版本校验
createVersionPolling({
  appETagKey: "__APP_ETAG__",
  pollingInterval: 60 * 1000, // 单位为毫秒
  silent: process.env.NODE_ENV === "development", // 开发环境下不检测
  onUpdate: (self) => {
    // 当检测到有新版本时，执行的回调函数，可以在这里提示用户刷新页面
    const result = confirm("页面有更新，点击确定刷新页面！");
    if (result) {
      self.onRefresh();
    } else {
      // self.onCancel();
      self.onRefresh();
    }
    // 强制更新可以用alert
    // alert('有新版本，请刷新页面');
  },
});
/**打印 */
import print from 'print-js'
Vue.prototype.$print = print
//hiprint 打印 需要使用jquery依赖
import jquery from 'jquery'
import { hiPrintPlugin } from 'vue-plugin-hiprint'
Vue.use(hiPrintPlugin, '$pluginName')
Vue.prototype.$ = jquery
Vue.config.productionTip = false
Vue.use(ElementUI, {
  size: 'small',
  zIndex: 3000
});
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
Number.prototype.toFixedRound = function(length)
{
  console.log(this)
  var carry = 0; //存放进位标志
  var num,multiple; //num为原浮点数放大multiple倍后的数，multiple为10的length次方
  var str = this + ''; //将调用该方法的数字转为字符串
  var dot = str.indexOf("."); //找到小数点的位置
  if(str.substr(dot+length+1,1)>=5) carry=1; //找到要进行舍入的数的位置，手动判断是否大于等于5，满足条件进位标志置为1
  multiple = Math.pow(10,length); //设置浮点数要扩大的倍数
  num = Math.floor(this * multiple) + carry; //去掉舍入位后的所有数，然后加上我们的手动进位数
  var result = num/multiple + ''; //将进位后的整数再缩小为原浮点数
  /*
  * 处理进位后无小数
  */
  dot = result.indexOf(".");
  if(dot < 0){
    result += '.';
    dot = result.indexOf(".");
  }
  /*
  * 处理多次进位
  */
  var len = result.length - (dot+1);
  if(len < length){
    for(var i = 0; i < length - len; i++){
      result += 0;
    }
  }
  console.log(result)
  return result;
}


